import React from "react";
import { formatDistance } from "tsi-common-react/src/apps/retail/helpers";
import { Link } from "tsi-common-react/src/components/Link/index";
import { useAppSelector } from "tsi-common-react/src/store/reducers";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import { nearestFlagshipStoreSelector } from "../selectors";

export const DistanceToStore = (): React.ReactNode => {
    const store = useAppSelector(nearestFlagshipStoreSelector);
    const storePageURL = usePageURL("tempur_pedic_stores");

    let text: string = t`See Closest Location`;
    if (store && store.distance) {
        const formattedDist = formatDistance(store.distance);
        text = t`${formattedDist} Miles Away`;
    }

    return <Link href={storePageURL}>{text}</Link>;
};
